/* Avatar.Group root element */
.group {
  --ag-spacing: var(--mantine-spacing-sm);
  --ag-offset: calc(var(--ag-spacing) * -1);

  display: flex;
  padding-inline-start: var(--ag-spacing);
}

/* Avatar root element */
.root {
  --avatar-size-xs: 16px;
  --avatar-size-sm: 26px;
  --avatar-size-md: 38px;
  --avatar-size-lg: 56px;
  --avatar-size-xl: 84px;

  --avatar-size: var(--avatar-size-md);
  --avatar-radius: 1000px;
  --avatar-bg: var(--mantine-color-gray-light);
  --avatar-bd: 1px solid transparent;
  --avatar-color: var(--mantine-color-gray-light-color);
  --avatar-placeholder-fz: calc(var(--avatar-size) / 2.5);

  -webkit-tap-highlight-color: transparent;
  position: relative;
  display: block;
  user-select: none;
  overflow: hidden;
  border-radius: var(--avatar-radius);
  text-decoration: none;
  padding: 0;
  width: var(--avatar-size);
  height: var(--avatar-size);
  min-width: var(--avatar-size);

  &:where([data-within-group]) {
    margin-inline-start: var(--ag-offset);
    border: 2px solid var(--mantine-color-body);
    background: var(--mantine-color-body);
  }
}

.image {
  object-fit: cover;
  width: 100%;
  height: 100%;
  display: block;
}

.placeholder {
  font-weight: var(--mantine-font-weight-bold);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  user-select: none;
  border-radius: var(--avatar-radius);
  font-size: var(--avatar-placeholder-fz);
  background: var(--avatar-bg);
  border: var(--avatar-bd);
  color: var(--avatar-color);

  & > [data-avatar-placeholder-icon] {
    width: 70%;
    height: 70%;
  }
}
